module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("I grew up in Inverell, a small rural town in north-east NSW. I started writing "), _c('em', [_vm._v("The Falling")]), _vm._v(" when I was 17. It took me 3 years to finally complete it. I dropped out of school at the start of grade 11, when I was 16. My first job was at a local jewellers’ that unfortunately closed early 2021. But I’m happy to say it was the best 5 years of my life working there, there was never a dull day with those lovely ladies. I am an animal fanatic, having many of mine, but we all have our favourites and mine are my two amazing cats: Pepsi and Minky. I’m a big fan of movies and my all-time favourite character is Batman.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("I love to write, mainly because it gives me a sense of freedom. I can shut off from the world around me and go anywhere I want. My biggest inspiration is Alexandra Adornetto. Her writing makes me feel like I’m there and her books make me feel so happy and I only want my book to bring the same joy to anyone who reads it. I’m not in it for the fame and fortune. I simply want to brighten up someone’s day, like Alexandra Adornetto did for me.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em",
      "text-align": "right"
    }
  }, [_vm._v("—Kita Cook")]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0